import { casOpsApi, CollectionModel, QueryTag, TagList } from '../api';
import { ModelWithId } from './commonModels';

export interface AssetCertificateModel extends ModelWithId {
  aid: number; // asset ID
  an: string; // asset name
  did: string; // device ID
  csr: string; // certificate signing request
  ts: string; // timestamp
}

export const assetCertificatesApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    getListCertificates: build.query<AssetCertificateModel[], void>({
      query: () => 'api/assetcertificates',
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.Certificate, id: TagList }] : [],
      transformResponse: ({ items }: CollectionModel<AssetCertificateModel>, meta, arg) => items,
    }),
    deleteCertificate: build.mutation<void, ModelWithId>({
      query: ({ id }) => ({
        url: `api/assetcertificates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) =>
        !error ? [{ type: QueryTag.Certificate, id: TagList }] : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetListCertificatesQuery, useDeleteCertificateMutation } = assetCertificatesApi;
